export default {
  name: 'my-image',
  template: `
    <img :src="imageSrc" :alt="section.title" :srcset="imageSrc + ' 1x, ' + imageSrcLarge + ' 2x'" class="c-image" :class="{'c-image--loaded': loaded}">
  `,
  props: {
    section: Object,
    route: String
  },
  data () {
    return {
      loaded: false
    }
  },
  computed: {
    imageSrc () {
      return require('@/assets/images/' + this.directory + '/' + this.section.slug + '.png')
    },
    imageSrcLarge () {
      return require('@/assets/images/' + this.directory + '/' + this.section.slug + '@2x.png')
    },
    directory () {
      return (this.route === 'landscape') ? 'landscape' : 'prosumer-wide'
    }
  },
  mounted () {
    let _this = this
    this.$el.onload = () => {
      _this.loaded = true
    }
  },
  updated () {
    // this.loaded = false
  }
}



// WEBPACK FOOTER //
// ./src/components/standard/my-image.js